import { useState, type SubmitEvent } from "react";
import { useStorageReducer } from "./hooks/customHooks";
import "./index.css";
import type { TodoType } from "./types/types";
import Calendar from "./components/Calendar";

export default function App() {
  return (
    <main>
      <Calendar></Calendar>
    </main>
  );
}
